import React, { useEffect, useState } from 'react'
import { styled } from '@mui/material/styles'
import Box from '@mui/material/Box'
import Paper from '@mui/material/Paper'
import Grid from '@mui/material/Grid'
import { Container, Typography } from '@mui/material'
import { makeGetRequest } from 'utils/api'
import './slider.css'
import ArrowDropUpIcon from '@mui/icons-material/ArrowDropUp'
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown'
import MarketCard from './cards/MarketCard'
import CommoditiesCard from './cards/CommoditiesCard'
import RealEstateCard from './cards/RealEstateCard'
import AlternativeInvestmentCard from './cards/AlternativeInvestmentCard'
import StartupsCard from './cards/StartupsCard'
import CurrencyExchange from './cards/CurrencyExchange'
const Item = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(2),
  backgroundColor: 'rgb(0, 27, 66)',
  color: 'white',
  //   height: '100%',
  height: 450,
  overflow: 'hidden',
}))

const items = Array.from({ length: 50 }, (_, i) => `Item ${i + 1}`)

export default function MarkeetTab() {
  const [reports, setReports] = useState([])
  useEffect(() => {
    getMarketView()
  }, [])
  const getMarketView = async () => {
    const { data } = await makeGetRequest('/api/investment/market-view/', {}, true)
    setReports([...data])
  }
  return (
    <>
      <Box
        sx={{
          mt: 1,
          width: '100%',
          overflow: 'hidden',
          color: 'white',
          display: 'flex',
          alignItems: 'center',
          position: 'relative',
        }}
      >
        <Box className="slider-track">
          {reports
            .find((r) => r.type === 'market_snapshot')
            ?.data.map((item, index) => (
              <Box
                key={index}
                sx={{
                  px: 2,
                  whiteSpace: 'nowrap',
                  display: 'inline-block',
                }}
              >
                <Typography variant="body1">
                  {item.indice_name} {parseFloat(item.price).toFixed(2)}
                  {item.variation_percent >= 0 ? (
                    <ArrowDropUpIcon sx={{ color: 'green', fontSize: '2.5rem' }} />
                  ) : (
                    <ArrowDropDownIcon sx={{ color: 'red', fontSize: '2.5rem' }} />
                  )}
                  <Box component={'samp'} color={item.variation_percent >= 0 ? 'green' : 'red'}>
                    {parseFloat(item.variation_percent).toFixed(2)}%
                  </Box>
                </Typography>
              </Box>
            ))}
        </Box>
      </Box>
      <Box sx={{ flexGrow: 1, pb: 6, mt: 1 }}>
        <Grid container spacing={1}>
          <Grid item xs={12} md={4}>
            <Item>
              <MarketCard result={reports.find((r) => r.type === 'financial_market')?.data} />
            </Item>
          </Grid>
          <Grid item xs={12} md={4}>
            <Item>
              <CommoditiesCard result={reports.find((r) => r.type === 'commodity_market')?.data} />
            </Item>
          </Grid>
          <Grid item xs={12} md={4}>
            <Item>
              <RealEstateCard
                result={reports.find((r) => r.type === 'real_estate_opportunity')?.data}
              />
            </Item>
          </Grid>
        </Grid>
        <Grid mt={1} container spacing={1}>
          <Grid item xs={12} md={4}>
            <Item>
              <AlternativeInvestmentCard
                result={reports.find((r) => r.type === 'alternatifs')?.data}
              />
            </Item>
          </Grid>
          <Grid item xs={12} md={4}>
            <Item>
              <StartupsCard result={reports.find((r) => r.type === 'startup_capital')?.data} />
            </Item>
          </Grid>
          <Grid item xs={12} md={4}>
            <Item>
              <CurrencyExchange
                result={reports.find((r) => r.type === 'currency_exchange')?.data}
              />
            </Item>
          </Grid>
        </Grid>
      </Box>
    </>
  )
}
